import { withViewComponent } from '@updater-local/custom-element-v1';
import '@updater-components/fa-icon';
import styles from './index.css';
const FEATURE_TYPES = ['services', 'affiliations', 'noteworthy'];

class Features extends withViewComponent(styles)() {
  static props = ['value'];

  updated({ value }) {
    this.render`
      ${FEATURE_TYPES.filter(
        featureType => (value[featureType] || []).length
      ).map(featureType => {
        return this.wire()`
            <div class="container">
              <div class="title">${featureType}</div>
              ${value[featureType].map(
                item => this.wire()`
                  <div class="item">
                    <upd-fa-icon name="check"></upd-fa-icon>
                    <span>${item}</span>
                  </div>
                `
              )}
            </div>
          `;
      })}
    `;
  }
}

customElements.define('upd-moveiq-company-features', Features);
